// extracted by mini-css-extract-plugin
module.exports = {"gradientBackgroundOptions":"ToggleButton_gradientBackgroundOptions__Gwz5K"};